import { useContext } from 'react';

import { UnleashKeys } from '../../constants/unleash-keys';

import { FeatureObservationsOnIdmContext } from './use-feature-observations-on-idm.context';

export const useFeatureObservationsOnIdm = () => {
  const { useFlag, useAppConfigContext } = useContext(
    FeatureObservationsOnIdmContext
  );

  const { isIdm } = useAppConfigContext();
  const isObservationsOnIdmUnleashFlagEnabled = useFlag(
    UnleashKeys.observations_on_idm_Q3
  );

  const isObservationsFeatureEnabledOnIdm =
    isIdm && isObservationsOnIdmUnleashFlagEnabled;

  return isObservationsFeatureEnabledOnIdm;
};
